import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { DatePicker } from 'ui-components/components/date-picker';
import { DateService } from '../../../../services/date-service';
import { MessageDescriptorPropType } from '../../../../prop-types/intl';
import style from './style.module.less';

const OrderSummaryDatePicker = ({ userDateFormat, labelTranslation, value, onSelectedDateChanged, allowPastDates = true, name }) => {
  const intl = useIntl();
  const onChange = useCallback(
    (time) => {
      onSelectedDateChanged(name, time);
    },
    [name, onSelectedDateChanged],
  );
  return (
    <div className={style['input-wrapper']}>
      <label className={style['input-label']}>{intl.formatMessage(labelTranslation)}</label>
      <DatePicker
        additionalDateFormats={DateService.getAdditionalDateFormats()}
        allowPastDates={allowPastDates}
        className={style['date-picker-input']}
        dateFormat={userDateFormat}
        label={intl.formatMessage(labelTranslation)}
        onChange={onChange}
        value={value || ''}
      />
    </div>
  );
};

OrderSummaryDatePicker.propTypes = {
  userDateFormat: PropTypes.string.isRequired,
  labelTranslation: MessageDescriptorPropType.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onSelectedDateChanged: PropTypes.func.isRequired,
  allowPastDates: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

export default OrderSummaryDatePicker;
